import { action, computed, makeObservable, observable } from "mobx";
import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { INoteObservable } from "@/store/note/types";
import { actions } from "@/actions";
import { TemplateObservable } from "@/store/templates/TemplateObservable";
import { NoteType } from "@/components/note/types";

interface DeleteNotePermanentlyModalStoreProps {
  handleConfirm?: () => void;
  onClose?: () => void;
  onDelete?: () => void;
}

export class DeleteNotePermanentlyModalStore extends AppSubStore {
  private handleConfirm?: () => void;
  private onClose?: () => void;
  private onDelete?: () => void;
  public notes: (INoteObservable | TemplateObservable)[] = [];

  constructor(injectedDeps: AppSubStoreArgs, props: DeleteNotePermanentlyModalStoreProps) {
    super(injectedDeps);

    this.handleConfirm = props.handleConfirm;
    this.onClose = props.onClose;
    this.onDelete = props.onDelete;

    makeObservable<this, "handleConfirm" | "onClose" | "onDelete">(this, {
      handleConfirm: false,
      onClose: false,
      onDelete: true,

      notes: observable,
      isOpen: computed,
      handleSubmit: action,
      open: action,
      close: action,
    });
  }

  get isOpen() {
    return !!this.notes.length;
  }

  public handleSubmit() {
    if (!this.notes.length) return;
    this.handleConfirm?.();
    actions.deleteNotesPermanently({
      notes: this.notes,
      store: this.store,
      noteType: this.notes[0] instanceof TemplateObservable ? NoteType.Template : NoteType.Note,
    });
    this.close();
    this.onClose?.();
    this.onDelete?.();
  }

  public open({ notes }: { notes: (INoteObservable | TemplateObservable)[] }) {
    this.notes = notes;
  }

  public close() {
    this.notes = [];
    this.onClose?.();
  }
}
